import { render, staticRenderFns } from "./ApartmentCreateOrEdit.vue?vue&type=template&id=9d5c19c6&"
import script from "./ApartmentCreateOrEdit.vue?vue&type=script&lang=js&"
export * from "./ApartmentCreateOrEdit.vue?vue&type=script&lang=js&"
import style0 from "./ApartmentCreateOrEdit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports